import styles from './index.module.css'

import React from 'react'

import { LuLockKeyhole } from '@react-icons/all-files/lu/LuLockKeyhole'

import { Flex, Text, Tooltip } from 'components/ds'

const HIDDEN_PLAYLISTS_TOOLTIP =
  'Other users in your DISCO might set a playlist as "Viewable only by me". This track is in one or more of those playlists. Keep that in mind when editing or deleting the track.'

/**
 * Playlists a track appears on that aren't visible to the viewer: the
 * remainder between the business-wide total and the viewer-scoped list.
 */
export const getHiddenPlaylistsCount = (
  totalCount: number | null | undefined,
  visibleCount: number,
): number =>
  typeof totalCount === 'number' ? Math.max(0, totalCount - visibleCount) : 0

type Props = { hiddenCount: number }

/**
 * Lock icon + tooltip surfacing playlists a track appears on that the
 * viewer can't see. Shared between the search "Appears on" hover card and
 * the explorer track pane's "Also appears on" tab.
 */
export const AppearsOnHiddenCount = ({ hiddenCount }: Props) => {
  if (hiddenCount <= 0) return null

  return (
    <Tooltip content={HIDDEN_PLAYLISTS_TOOLTIP} maxWidth="250px">
      <Flex align="center" gap="1" data-testid="appears-on-hidden-count">
        <LuLockKeyhole size={12} />
        <Text size="1" color="gray" className={styles.hiddenCountText}>
          {`${hiddenCount} more ${
            hiddenCount === 1 ? 'playlist' : 'playlists'
          } not visible to you`}
        </Text>
      </Flex>
    </Tooltip>
  )
}
